(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.ZugStandardStickerNativeBase = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var STRATEGY = 'native_product_base_plus_product_exact_cent_adjustments';
  var CONTRACT_VERSION = 'standard_sticker_native_base_v2';

  function positiveInteger(value) {
    var parsed = Number(value);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
  }

  function readContract(container) {
    var eligible = !!container &&
      container.getAttribute('data-zug-standard-sticker-native-base') === 'true';
    if (!eligible) return { eligible: false, valid: false };

    var contract = {
      eligible: true,
      productId: positiveInteger(
        container.getAttribute('data-zug-standard-sticker-product-id')
      ),
      baseVariantId: positiveInteger(
        container.getAttribute('data-zug-standard-sticker-native-variant-id')
      ),
      basePriceCents: positiveInteger(
        container.getAttribute('data-zug-standard-sticker-native-variant-price-cents')
      ),
      dollarVariantId: positiveInteger(
        container.getAttribute('data-zug-standard-sticker-dollar-variant-id')
      ),
      centVariantId: positiveInteger(
        container.getAttribute('data-zug-standard-sticker-cent-variant-id')
      )
    };
    contract.valid = !!(
      contract.productId &&
      contract.baseVariantId &&
      contract.basePriceCents &&
      contract.dollarVariantId &&
      contract.centVariantId &&
      contract.dollarVariantId !== contract.centVariantId
    );
    return contract;
  }

  function copyProperties(properties) {
    var copy = {};
    Object.keys(properties || {}).forEach(function (key) {
      copy[key] = properties[key];
    });
    return copy;
  }

  function adjustmentProperties(uid, unit) {
    return {
      _pricing_engine: 'true',
      _line_type: 'adjustment',
      calc_line_uid: uid,
      _carrier_role: 'exact_price_adjustment',
      _pricing_adjustment: 'true',
      _adjustment_unit: unit,
      _carrier_strategy: STRATEGY,
      _carrier_contract: CONTRACT_VERSION
    };
  }

  function buildBundle(input) {
    var baseVariantId = positiveInteger(input && input.baseVariantId);
    var basePriceCents = positiveInteger(input && input.basePriceCents);
    var dollarVariantId = positiveInteger(input && input.dollarVariantId);
    var centVariantId = positiveInteger(input && input.centVariantId);
    var targetTotalCents = positiveInteger(input && input.targetTotalCents);
    var uid = String(input && input.uid || '').trim();

    if (!uid || !baseVariantId || !basePriceCents || !dollarVariantId ||
        !centVariantId || !targetTotalCents ||
        dollarVariantId === centVariantId) {
      throw new Error('Invalid Standard Sticker native-base contract.');
    }
    if (basePriceCents > targetTotalCents) {
      throw new Error('Standard Sticker native base exceeds the configured total.');
    }

    var remainderCents = targetTotalCents - basePriceCents;
    var dollarQuantity = Math.floor(remainderCents / 100);
    var centQuantity = remainderCents % 100;
    var baseProperties = copyProperties(input.baseProperties);
    baseProperties._carrier_strategy = STRATEGY;
    baseProperties._carrier_contract = CONTRACT_VERSION;

    var items = [{
      id: baseVariantId,
      quantity: 1,
      properties: baseProperties
    }];
    if (dollarQuantity > 0) {
      items.push({
        id: dollarVariantId,
        quantity: dollarQuantity,
        properties: adjustmentProperties(uid, 'dollar')
      });
    }
    if (centQuantity > 0) {
      items.push({
        id: centVariantId,
        quantity: centQuantity,
        properties: adjustmentProperties(uid, 'cent')
      });
    }

    var reconstructedTotalCents =
      basePriceCents + dollarQuantity * 100 + centQuantity;
    if (reconstructedTotalCents !== targetTotalCents) {
      throw new Error('Standard Sticker exact-price reconstruction failed.');
    }

    return {
      items: items,
      targetTotalCents: targetTotalCents,
      basePriceCents: basePriceCents,
      remainderCents: remainderCents,
      dollarQuantity: dollarQuantity,
      centQuantity: centQuantity,
      reconstructedTotalCents: reconstructedTotalCents
    };
  }

  function hasArtwork(properties) {
    return Object.keys(properties || {}).some(function (key) {
      return key === '_artwork_mode' ||
        key === '_upload_id' ||
        key === '_artwork_original_url' ||
        key === '_dcf_preview_url' ||
        key === '_previous_order_number' ||
        /^Artwork \d+$/.test(key);
    });
  }

  function validateCart(cart, input) {
    var expected = buildBundle({
      uid: input.uid,
      baseVariantId: input.baseVariantId,
      basePriceCents: input.basePriceCents,
      dollarVariantId: input.dollarVariantId,
      centVariantId: input.centVariantId,
      targetTotalCents: input.targetTotalCents,
      baseProperties: {}
    });
    var lines = (cart && cart.items || []).filter(function (item) {
      return item.properties && item.properties.calc_line_uid === input.uid;
    });
    var bases = lines.filter(function (item) {
      return item.properties && item.properties._line_type === 'base';
    });
    var adjustments = lines.filter(function (item) {
      return item.properties && item.properties._line_type === 'adjustment';
    });
    var actualTotalCents = lines.reduce(function (sum, item) {
      return sum + Number(item.final_line_price || 0);
    }, 0);
    var base = bases[0];
    var expectedAdjustments = expected.items.slice(1);
    var artworkOnAdjustment = adjustments.some(function (item) {
      return hasArtwork(item.properties);
    });
    var adjustmentLinesValid = adjustments.length === expectedAdjustments.length &&
      expectedAdjustments.every(function (expectedItem) {
        return adjustments.some(function (actualItem) {
          return Number(actualItem.id) === expectedItem.id &&
            Number(actualItem.quantity) === expectedItem.quantity &&
            actualItem.properties &&
            actualItem.properties._adjustment_unit ===
              expectedItem.properties._adjustment_unit;
        });
      });
    var valid = lines.length === expected.items.length &&
      bases.length === 1 &&
      Number(base.id) === Number(input.baseVariantId) &&
      Number(base.quantity) === 1 &&
      actualTotalCents === Number(input.targetTotalCents) &&
      adjustmentLinesValid &&
      !artworkOnAdjustment;

    return {
      valid: valid,
      base: base || null,
      baseLineCount: bases.length,
      actualTotalCents: actualTotalCents,
      adjustmentLinesValid: adjustmentLinesValid,
      artworkOnAdjustment: artworkOnAdjustment
    };
  }

  function verifyOrRollback(cart, input, rollback) {
    var result;
    try {
      result = validateCart(cart, input);
    } catch (error) {
      result = { valid: false, validationError: error.message };
    }
    if (result.valid) return Promise.resolve(result);

    console.error('[ZUG][STANDARD_STICKER] Cart verification failed.', result);
    return Promise.resolve()
      .then(rollback)
      .then(function () {
        throw new Error('Standard Sticker cart verification failed; bundle rolled back.');
      }, function (rollbackError) {
        throw new Error(
          'Standard Sticker cart verification failed and rollback failed: ' +
          (rollbackError && rollbackError.message || rollbackError)
        );
      });
  }

  function readCart(fetchFunction) {
    return fetchFunction('/cart.js', {
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read cart for rollback.');
      return response.json();
    });
  }

  function rollbackBundle(input) {
    var fetchFunction = input && input.fetch;
    var uid = String(input && input.uid || '').trim();
    var keys = Array.isArray(input && input.keys) ? input.keys.slice() : [];
    if (typeof fetchFunction !== 'function' || !uid) {
      return Promise.reject(new Error('Invalid Standard Sticker rollback contract.'));
    }

    return readCart(fetchFunction)
      .then(function (cart) {
        (cart.items || []).forEach(function (item) {
          if (item.properties && item.properties.calc_line_uid === uid &&
              item.key && keys.indexOf(item.key) === -1) {
            keys.push(item.key);
          }
        });
        if (!keys.length) return null;

        var updates = {};
        keys.forEach(function (key) {
          updates[key] = 0;
        });
        return fetchFunction('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ updates: updates }),
          credentials: 'same-origin'
        }).then(function (response) {
          if (!response.ok) throw new Error('Standard Sticker rollback request failed.');
        });
      })
      .then(function () {
        return readCart(fetchFunction);
      })
      .then(function (cart) {
        var remains = (cart.items || []).some(function (item) {
          return item.properties && item.properties.calc_line_uid === uid;
        });
        if (remains) throw new Error('Standard Sticker rollback verification failed.');
        return { rolledBack: true, keys: keys };
      });
  }

  return {
    STRATEGY: STRATEGY,
    CONTRACT_VERSION: CONTRACT_VERSION,
    readContract: readContract,
    adjustmentProperties: adjustmentProperties,
    buildBundle: buildBundle,
    validateCart: validateCart,
    verifyOrRollback: verifyOrRollback,
    rollbackBundle: rollbackBundle
  };
});
